// One self-opening popup at a time (the Studio tour, the LinkedIn bonus): whoever comes second waits until the first
// is closed, so they never stack. Lives in memory only; a reload starts free.
let holder = null;

export function popupBusy(name) {
  return holder !== null && holder !== name;
}

export function takePopup(name) {
  if (popupBusy(name)) return false;
  holder = name;
  return true;
}

export function releasePopup(name) {
  if (holder === name) holder = null;
}
